/* Paper Easel store sections: hero slideshow, shop filter + add to cart, Veterans Day story,
   Try it at home (photo stays in the browser), free 2-pack checkout, offer end dates. */
(function () {
  'use strict';
  var timers = [];

  function parseEnd(s) {
    if (!s) return null;
    var m = String(s).match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2}))?\s*([+-]\d{2}):?(\d{2})?$/);
    if (!m) { var d = Date.parse(s); return isNaN(d) ? null : d; }
    var iso = m[1] + '-' + m[2] + '-' + m[3] + 'T' + (m[4] || '23') + ':' + (m[5] || '59') + ':00' + m[6] + ':' + (m[7] || '00');
    return Date.parse(iso);
  }

  function toast(msg, link) {
    var t = document.getElementById('pe-toast');
    if (!t) { t = document.createElement('div'); t.id = 'pe-toast'; t.className = 'pe pe-toast-wrap'; t.innerHTML = '<div class="toast" role="status" aria-live="polite"></div>'; document.body.appendChild(t); }
    var box = t.firstChild;
    box.innerHTML = '';
    box.appendChild(document.createTextNode(msg + ' '));
    if (link) { var a = document.createElement('a'); a.href = link.href; a.textContent = link.text; box.appendChild(a); }
    box.classList.add('show');
    clearTimeout(t._h); t._h = setTimeout(function () { box.classList.remove('show'); }, 4000);
  }

  function updateCartBubble(count) {
    var icon = document.querySelector('cart-icon');
    if (icon && typeof icon.renderCartBubble === 'function') { try { icon.renderCartBubble(count); return; } catch (e) {} }
    document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) { el.textContent = count; });
  }

  function init(root) {
    root = root || document;

    /* offers and seasonal sections that have ended */
    root.querySelectorAll('[data-pe-ends]').forEach(function (el) {
      var end = parseEnd(el.getAttribute('data-pe-ends'));
      if (end && Date.now() >= end && !window.Shopify?.designMode) el.remove();
    });

    /* hero slideshow */
    root.querySelectorAll('[data-pe-hero]').forEach(function (hero) {
      if (hero._pe) return; hero._pe = true;
      var slogans = [].slice.call(hero.querySelectorAll('.slogan')), imgs = [].slice.call(hero.querySelectorAll('.hero-img')), dots = hero.querySelector('.slide-dots');
      var ms = (parseInt(hero.getAttribute('data-interval'), 10) || 8) * 1000, si = 0, timer;
      function go(i) {
        si = i;
        slogans.forEach(function (s, j) { s.classList.toggle('is-active', j === i); s.setAttribute('aria-hidden', j !== i); });
        imgs.forEach(function (im, j) { im.classList.toggle('is-active', j === i); });
        dots.querySelectorAll('button').forEach(function (b, j) { b.setAttribute('aria-selected', j === i); });
      }
      function restart() { clearInterval(timer); if (!matchMedia('(prefers-reduced-motion: reduce)').matches && slogans.length > 1) { timer = setInterval(function () { go((si + 1) % slogans.length); }, ms); timers.push(timer); } }
      dots.innerHTML = '';
      slogans.forEach(function (_, i) { var b = document.createElement('button'); b.type = 'button'; b.setAttribute('role', 'tab'); b.setAttribute('aria-label', 'Headline ' + (i + 1)); b.setAttribute('aria-selected', i === 0); b.addEventListener('click', function () { go(i); restart(); }); dots.appendChild(b); });
      restart();
    });

    /* shop filter */
    root.querySelectorAll('#shop').forEach(function (shop) {
      if (shop._pe) return; shop._pe = true;
      var note = shop.querySelector('#shopNote');
      shop.querySelectorAll('.chip').forEach(function (c) {
        c.addEventListener('click', function () { setFilter(shop, c.getAttribute('data-filter'), note); });
      });
    });
    function setFilter(shop, f, note) {
      shop.querySelectorAll('.chip').forEach(function (c) { var on = c.getAttribute('data-filter') === f; c.classList.toggle('is-on', on); c.setAttribute('aria-selected', on); if (on && note) { var n = c.getAttribute('data-note'); if (n) note.textContent = n; } });
      shop.querySelectorAll('.card[data-groups]').forEach(function (card) { card.hidden = (' ' + card.getAttribute('data-groups') + ' ').indexOf(' ' + f + ' ') < 0; });
    }
    /* links like /#shop?filter=card or #shop-card choose a filter */
    var applyHash = function () { var m = location.hash.match(/^#shop-([\w-]+)/); if (!m) return; var shopEl = document.getElementById('shop'); if (shopEl) { setFilter(shopEl, m[1], shopEl.querySelector('#shopNote')); shopEl.scrollIntoView(); } };
    applyHash();
    if (!window._peHash) { window._peHash = true; window.addEventListener('hashchange', applyHash); }

    /* add to cart */
    root.querySelectorAll('[data-pe-add]').forEach(function (btn) {
      if (btn._pe) return; btn._pe = true;
      btn.addEventListener('click', function () {
        btn.disabled = true;
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +btn.getAttribute('data-pe-add'), quantity: 1 }] }) })
          .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
          .then(function () { return fetch('/cart.js').then(function (r) { return r.json(); }); })
          .then(function (cart) {
            updateCartBubble(cart.item_count);
            var e = btn.getAttribute('data-easels');
            toast('Added: ' + btn.getAttribute('data-name') + (e ? ' (' + e + ' easels).' : '.'), { href: '/cart', text: 'View cart' });
          })
          .catch(function (err) { toast((err && (err.description || err.message)) || 'Sorry, that could not be added.'); })
          .finally(function () { btn.disabled = false; });
      });
    });

    /* Veterans Day story dialog */
    var sm = root.querySelector('#storyModal') || document.getElementById('storyModal');
    if (sm && !sm._pe) {
      sm._pe = true;
      document.body.appendChild(sm.parentNode === document.body ? sm : (function () { var w = document.createElement('div'); w.className = 'pe'; w.appendChild(sm); return w; })());
      var last = null;
      var open = function (e) { if (e) e.preventDefault(); last = document.activeElement; sm.hidden = false; document.documentElement.style.overflow = 'hidden'; sm.querySelector('.story-card').scrollTop = 0; sm.querySelector('.modal-close').focus(); };
      var close = function () { if (sm.hidden) return; sm.hidden = true; document.documentElement.style.overflow = ''; if (last && last.focus) last.focus(); };
      document.querySelectorAll('[data-story-open]').forEach(function (b) { b.addEventListener('click', open); });
      sm.querySelectorAll('[data-story-close]').forEach(function (b) { b.addEventListener('click', close); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
      if (location.hash === '#story') open();
    }

    /* Try it at home: the photo never leaves the browser */
    var stage = root.querySelector('#tryStage');
    if (stage && !stage._pe) {
      stage._pe = true;
      var box = root.querySelector('#tryPhoto'), file = root.querySelector('#tryFile'), msg = root.querySelector('#tryMsg'), clr = root.querySelector('#tryClear'), ex = root.querySelector('#tryExample'), url = null;
      var show = function (src, isBlob) {
        var im = new Image();
        im.onload = function () { stage.setAttribute('data-orient', im.naturalHeight > im.naturalWidth * 1.05 ? 'port' : 'land'); box.innerHTML = ''; im.alt = ''; box.appendChild(im); clr.hidden = false; msg.textContent = msg.getAttribute('data-done') || ''; };
        im.onerror = function () { msg.textContent = "That file couldn't be opened. Please choose a JPG or PNG photo."; };
        if (url && isBlob) URL.revokeObjectURL(url);
        if (isBlob) url = src;
        im.src = src;
      };
      file.addEventListener('change', function () { var f = file.files && file.files[0]; if (!f) return; if (!/^image\//.test(f.type)) { msg.textContent = 'Please choose a photo file.'; return; } show(URL.createObjectURL(f), true); file.value = ''; });
      if (ex) ex.addEventListener('click', function () { show(ex.getAttribute('data-src'), false); });
      clr.addEventListener('click', function () { box.innerHTML = '<span class="try-empty">Your picture here</span>'; stage.setAttribute('data-orient', 'land'); clr.hidden = true; msg.textContent = ''; if (url) { URL.revokeObjectURL(url); url = null; } });
    }

    /* Free 2-pack: replace the cart with the chosen design, apply the code, go to checkout */
    root.querySelectorAll('[data-pe-free]').forEach(function (wrap) {
      if (wrap._pe) return; wrap._pe = true;
      var go = wrap.querySelector('[data-pe-free-go]'), sel = wrap.querySelector('[data-pe-free-variant]'), code = wrap.getAttribute('data-code');
      go.addEventListener('click', function () {
        go.disabled = true;
        fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
          .then(function () { return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +sel.value, quantity: 1 }] }) }); })
          .then(function (r) { if (!r.ok) throw new Error('add'); location.href = '/discount/' + encodeURIComponent(code) + '?redirect=/checkout'; })
          .catch(function () { go.disabled = false; toast('Sorry, something went wrong. Please try again.'); });
      });
      if (location.search.indexOf('customer_posted=true') > -1) { var sec = document.getElementById('free'); if (sec) sec.scrollIntoView(); }
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
